import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('I_OWN_THIS_SETTINGS', {
  CREATE_I_OWN_THIS_SETTING_REQUEST: null,
  CREATE_I_OWN_THIS_SETTING_SUCCESS: null,
  CREATE_I_OWN_THIS_SETTING_FAILURE: null,
  REMOVE_I_OWN_THIS_SETTING_REQUEST: null,
  REMOVE_I_OWN_THIS_SETTING_SUCCESS: null,
  REMOVE_I_OWN_THIS_SETTING_FAILURE: null
});
